WB.DataServices = WB.DataServices || {};

WB.DataServices.Metadata = function ($http, $q, $location) {

    this.GetMetadataForUrl = function(url) {
        const result = $q(function(resolve, reject) {
            const didMassageUrl = !!url;
            const currentPagePath = $location.url();
            url = url || currentPagePath;
            let reqObj = {
                method: 'GET',
                url: url,
                params: { metadata: true }
            };
            if (didMassageUrl && !currentPagePath?.startsWith('/weather-videos')) {
                reqObj = {
                    ...reqObj,
                    params: {
                        metadata: true,
                        ignoreSlugName: true // TechDebt: avoid reverting location bugfixes and track appended slugName so server can ignore
                    }
                };
            }
            $http(reqObj)
                .success(resolve)
                .error(function(data) {
                    reject(new Error('Unable to get metadata.'));
                });
        });
        return result;
    };

};
WB.DataServices.Metadata.$inject = ['$http', '$q', '$location'];

WB.Core.service('MetadataDataService', WB.DataServices.Metadata);
